"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translate_1 = require("components/translate");
const OfferName = ({ offerActivationCode, children }) => {
    return ((0, jsx_runtime_1.jsxs)("span", { children: [offerActivationCode || (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "general.default" }), children] }));
};
exports.default = OfferName;
